import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

/**
 * provides a visual progress component
 * which may show dynamic progress based on input value (0-100)
 * @class ProgressComponent
 * @typedef {ProgressComponent}
 */
@Component( {
    selector: 'riege-progress',
    imports: [CommonModule],
    templateUrl: './progress.component.html',
    styleUrls: ['./progress.component.scss'],
    standalone: true
} )
export class ProgressComponent {
    /** progress input value (0-100) */
    @Input() progress = 0;
}
